import {useCallback, useEffect, useRef, useState} from 'react';

/**
 * Get states of scroll on ref hook
 * @param {Array<{id: number; isDetailsOpen: boolean}>} itemsDetailsStates - items of scroll container
 * @return {ScrollStatesType} - states of scroll
 */
export const useScrollStates = (
    itemsDetailsStates: Array<{id: number; isDetailsOpen: boolean}>,
) => {
    const [isScrollOnTop, setScrollOnTop] = useState(true);
    const [isScrollOnBottom, setScrollOnBottom] = useState(true);

    const scrollRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!itemsDetailsStates.find(({isDetailsOpen}) => isDetailsOpen)) {
            setScrollOnBottom(true);
        }
    }, [itemsDetailsStates]);

    const handleScroll = useCallback(() => {
        const handleScrollOnTop = () => {
            if (scrollRef.current) {
                if (!isScrollOnTop && !scrollRef.current.scrollTop) {
                    setScrollOnTop(true);
                }
                if (isScrollOnTop && scrollRef.current.scrollTop) {
                    setScrollOnTop(false);
                }
            }
        };

        if (scrollRef.current) {
            handleScrollOnTop();
            const {clientHeight, scrollHeight, scrollTop} = scrollRef.current;
            if (!isScrollOnBottom && Math.trunc(scrollHeight - scrollTop) <= clientHeight) {
                setScrollOnBottom(true);
            }
            if (isScrollOnBottom && Math.trunc(scrollHeight - scrollTop) !== clientHeight) {
                setScrollOnBottom(false);
            }
        }
    }, [isScrollOnBottom, isScrollOnTop]);

    return {handleScroll, isScrollOnBottom, isScrollOnTop, scrollRef};
};
